<!-- Content -->
<div class="content container-fluid">
  <!-- Page Header -->
  <header class="page-header">
    <nav attr.aria-label="{{ 'wcag.breadcrumb' | translate }}">
      <ol class="breadcrumb">
        <breadcrumb></breadcrumb>

        <li
          class="breadcrumb-item active"
          *ngIf="(rolePermissions$ | async)?.type"
        >
          &nbsp; / &nbsp;
          {{ (rolePermissions$ | async)?.type }}
        </li>
      </ol>
    </nav>

    <h1 class="page-header-title">
      {{ (rolePermissions$ | async)?.type }}
    </h1>

    <h1 class="page-header-title">
      {{ 'rolePermissionsModule.editRolePermissions' | translate }}
    </h1>
  </header>
  <!-- End Page Header -->

  <div class="w-100">
    <router-outlet></router-outlet>
  </div>
</div>
